<template>
  <div v-if="count > 0">
    <div class="border shadow rounded p-3 d-flex align-items-center justify-content-between">
      <div class="small">
        <i class="bi bi-exclamation-triangle text-warning me-2"></i>
        <strong>{{ count }}</strong> {{ count === 1 ? 'order needs' : 'orders need' }} COGS review
      </div>
      <router-link :to="{ name: 'Settings-DataCogs' }" class="btn btn-sm btn-outline-warning">
        Review
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const count = ref(0)

onMounted(() => {
  store.dispatch('eshop/getUnreversedCogsOrders', { days: 45 })
    .then(data => { count.value = data?.length || 0 })
    .catch(() => {})
})
</script>
